import { customShadows } from '../custom-shadows';

// ----------------------------------------------------------------------

export function createContrast(contrast: 'bold' | 'default') {
  const components = {
    ...(contrast === 'bold' && {
      MuiCard: {
        styleOverrides: {
          root: {
            boxShadow: customShadows().z1,
          },
        },
      },
    }),
  };

  return {
    components,
  };
}
